import React from 'react'
import { createRoot } from 'react-dom/client'
import Contact from "./Contact.jsx"
import Mtm from "./Mtm.jsx"
import FormLead from "./FormLead.jsx"

document.addEventListener('DOMContentLoaded', () => {
  const contactFormWrapper = document.querySelector('[data-salesforce-contact]')
  if(contactFormWrapper) {
    const contactFormRoot = createRoot(contactFormWrapper)
    contactFormRoot.render(<Contact />)
  }

  const mtmFormWrapper = document.querySelector('[data-salesforce-mtm]')
  if(mtmFormWrapper) {
    const mtmFormRoot = createRoot(mtmFormWrapper)
    mtmFormRoot.render(<Mtm />)
  }

  const leadFormWrappers = document.querySelectorAll('[data-form-lead]')
  leadFormWrappers.forEach(wrapper => {
    const sectionId = wrapper.getAttribute('data-section-id')
    const formConfig = window.formLeadObj?.[sectionId]

    if (formConfig) {
      const leadFormRoot = createRoot(wrapper)
      leadFormRoot.render(<FormLead config={formConfig} />)
    }
  })
})